import axios from "axios";
import { baseUrl, buildQuery } from "../config/api-config";


export function getAllProject(token,query) {
    const qs = buildQuery(query);
    return axios.get(`${baseUrl}/allprojects${qs}`, {
      headers: {
        authorization: token,
      },
    });
  }

  export function InsertProject(data, token) {
    return axios.post(baseUrl + "/InsertNewProject", data, {
      headers: {
        Authorization: token,
      },
    });
  }
 
 
  export function ProjectDatabyId(token,query) {
    const qs = buildQuery(query);
    return axios.get(baseUrl + `/getprojectbyId${qs}`, {
      headers: {
        Authorization: token,
      },
    });
  }
  export function UpdateProject(token,data,id) {
    return axios.patch(baseUrl + `/UpdateProjectbyId/${id}`,data, {
      headers: {
        Authorization: token,
      },
    });
  }
  export function deleteProject(token,id) {
    return axios.delete(baseUrl + `/deleteproject/${id}`, {
      headers: {
        Authorization: token,
      },
    });
  }
  export function insertMultipleMilestoneandTask(token,data,query){
    const qs = buildQuery(query);
    return axios.post(baseUrl + `/InsertmultipleMilestoneandTask${qs}`,data, {
      headers: {
        Authorization: token,
      },
    });
  }
 
  
  
export function getTaskStatusGraph( token,id) {
    return axios.get(baseUrl + `/getTaskStatusGraph?project_id=${id}`, {
      headers: {
        Authorization: token,
      },
    });
  };
  export function getTaskPriorityGraph( token,id) {
    return axios.get(baseUrl + `/getTaskPriorityGraph?project_id=${id}`, {
      headers: {
        Authorization: token,
      },
    });
  };
  export function getProjectBudgetVsActual( token,id) {
    return axios.get(baseUrl + `/getProjectBudgetVsActual?project_id=${id}`, {
      headers: {
        Authorization: token,
      },
    });
  };
  export function getTaskTimelineChart( token,id) {
    return axios.get(baseUrl + `/getTaskTimelineChart?project_id=${id}`, {
      headers: {
        Authorization: token,
      },
    });
  };
  